module.exports = __webpack_public_path__ + "static/media/all-set-desktop.cb526382.svg";